
import { useEffect, useState, useCallback } from 'react';
import { centralizedSessionService, SessionState } from '@/services/centralizedSessionService';

export const useCentralizedSession = () => {
  const [sessionState, setSessionState] = useState<SessionState>(
    centralizedSessionService.getState()
  );

  useEffect(() => {
    // Subscribe to session changes
    const unsubscribe = centralizedSessionService.subscribe(setSessionState);
    
    // Initialize session on mount
    centralizedSessionService.initializeSession();

    return unsubscribe;
  }, []);

  const login = useCallback(async (email: string, password: string) => {
    return centralizedSessionService.login(email, password);
  }, []);

  const logout = useCallback(async () => {
    return centralizedSessionService.logout();
  }, []);

  return {
    user: sessionState.user,
    isAuthenticated: !!sessionState.user,
    isLoading: sessionState.isLoading,
    error: sessionState.error,
    sessionToken: sessionState.sessionToken,
    login,
    logout
  };
};
